"use strict";
class $a5fd07fa01589658$export$2e2bcd8739ae039 {
    static SIZE = 4;
    static WIN_TILE = 2048;
    constructor(initialState = null){
        this.initialState = initialState ? $a5fd07fa01589658$export$2e2bcd8739ae039._deepCopyBoard(initialState) : $a5fd07fa01589658$export$2e2bcd8739ae039._emptyBoard();
        this.board = $a5fd07fa01589658$export$2e2bcd8739ae039._deepCopyBoard(this.initialState);
        this.score = 0;
        this.status = "not_started";
        this._hasStarted = false;
    }
    getState() {
        return $a5fd07fa01589658$export$2e2bcd8739ae039._deepCopyBoard(this.board);
    }
    getScore() {
        return this.score;
    }
    getStatus() {
        return this.status;
    }
    start() {
        if (this._hasStarted) return;
        this._hasStarted = true;
        this.status = "playing";
        if ($a5fd07fa01589658$export$2e2bcd8739ae039._isBoardEmpty(this.board)) {
            this._spawnRandom();
            this._spawnRandom();
        }
    }
    restart() {
        this.board = $a5fd07fa01589658$export$2e2bcd8739ae039._deepCopyBoard(this.initialState);
        this.score = 0;
        this.status = "not_started";
        this._hasStarted = false;
    }
    moveLeft() {
        return this._move((row)=>$a5fd07fa01589658$export$2e2bcd8739ae039._moveArrayLeft(row));
    }
    moveRight() {
        return this._move((row)=>$a5fd07fa01589658$export$2e2bcd8739ae039._moveArrayRight(row));
    }
    moveUp() {
        this.board = $a5fd07fa01589658$export$2e2bcd8739ae039._transpose(this.board);
        const moved = this._move((row)=>$a5fd07fa01589658$export$2e2bcd8739ae039._moveArrayLeft(row));
        this.board = $a5fd07fa01589658$export$2e2bcd8739ae039._transpose(this.board);
        return moved;
    }
    moveDown() {
        this.board = $a5fd07fa01589658$export$2e2bcd8739ae039._transpose(this.board);
        const moved = this._move((row)=>$a5fd07fa01589658$export$2e2bcd8739ae039._moveArrayRight(row));
        this.board = $a5fd07fa01589658$export$2e2bcd8739ae039._transpose(this.board);
        return moved;
    }
    _move(transformRowFn) {
        if (this.status === "over" || this.status === "won") return false;
        if (!this._hasStarted) this.start();
        const beforeState = JSON.stringify(this.board);
        let mergedSumThisMove = 0;
        const newBoard = this.board.map((row)=>{
            const { newRow: newRow, mergedSum: mergedSum } = transformRowFn(row);
            mergedSumThisMove += mergedSum;
            return newRow;
        });
        if (JSON.stringify(newBoard) === beforeState) return false;
        this.board = newBoard;
        this.score += mergedSumThisMove;
        if ($a5fd07fa01589658$export$2e2bcd8739ae039._boardHasValue(this.board, $a5fd07fa01589658$export$2e2bcd8739ae039.WIN_TILE)) this.status = "won";
        this._spawnRandom();
        if (!this._hasAnyMoves()) this.status = "over";
        else if (this.status !== "won") this.status = "playing";
        return true;
    }
    _spawnRandom() {
        const emptyCells = [];
        for(let rowIdx = 0; rowIdx < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; rowIdx++){
            for(let colIdx = 0; colIdx < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; colIdx++)if (this.board[rowIdx][colIdx] === 0) emptyCells.push([
                rowIdx,
                colIdx
            ]);
        }
        if (emptyCells.length === 0) return false;
        const [r, c] = emptyCells[Math.floor(Math.random() * emptyCells.length)];
        const value = Math.random() < 0.1 ? 4 : 2;
        this.board[r][c] = value;
        return true;
    }
    _hasAnyMoves() {
        if ($a5fd07fa01589658$export$2e2bcd8739ae039._isBoardEmptyCellPresent(this.board)) return true;
        for(let rowIdx = 0; rowIdx < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; rowIdx++)for(let colIdx = 0; colIdx < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE - 1; colIdx++){
            if (this.board[rowIdx][colIdx] === this.board[rowIdx][colIdx + 1]) return true;
        }
        for(let colIdx = 0; colIdx < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; colIdx++)for(let rowIdx = 0; rowIdx < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE - 1; rowIdx++){
            if (this.board[rowIdx][colIdx] === this.board[rowIdx + 1][colIdx]) return true;
        }
        return false;
    }
    static _emptyBoard() {
        return Array.from({
            length: $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE
        }, ()=>Array($a5fd07fa01589658$export$2e2bcd8739ae039.SIZE).fill(0));
    }
    static _deepCopyBoard(board) {
        return board.map((row)=>row.slice());
    }
    static _isBoardEmpty(board) {
        for(let i = 0; i < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; i++)for(let j = 0; j < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; j++){
            if (board[i][j] !== 0) return false;
        }
        return true;
    }
    static _isBoardEmptyCellPresent(board) {
        for(let i = 0; i < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; i++)for(let j = 0; j < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; j++){
            if (board[i][j] === 0) return true;
        }
        return false;
    }
    static _boardHasValue(board, value) {
        for(let i = 0; i < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; i++)for(let j = 0; j < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; j++){
            if (board[i][j] === value) return true;
        }
        return false;
    }
    static _transpose(board) {
        const newBoard = $a5fd07fa01589658$export$2e2bcd8739ae039._emptyBoard();
        for(let i = 0; i < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; i++)for(let j = 0; j < $a5fd07fa01589658$export$2e2bcd8739ae039.SIZE; j++)newBoard[j][i] = board[i][j];
        return newBoard;
    }
    static _moveArrayLeft(row) {
        const size = row.length;
        const tiles = row.filter((v)=>v !== 0);
        const mergedFlags = Array(tiles.length).fill(false);
        let mergedSum = 0;
        for(let i = 0; i < tiles.length - 1; i++)if (!mergedFlags[i] && tiles[i] === tiles[i + 1]) {
            tiles[i] *= 2;
            mergedSum += tiles[i];
            tiles.splice(i + 1, 1);
            mergedFlags[i] = true;
            mergedFlags.splice(i + 1, 1);
        }
        const newRow = tiles.concat(Array(size - tiles.length).fill(0));
        return {
            newRow: newRow,
            mergedSum: mergedSum
        };
    }
    static _moveArrayRight(row) {
        const reversed = row.slice().reverse();
        const { newRow: newRow, mergedSum: mergedSum } = $a5fd07fa01589658$export$2e2bcd8739ae039._moveArrayLeft(reversed);
        return {
            newRow: newRow.reverse(),
            mergedSum: mergedSum
        };
    }
}


"use strict";
const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$cells = Array.from(document.querySelectorAll(".field-cell"));
const $09e991522ca7e64e$var$scoreEl = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startBtn = document.querySelector(".button");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
function $09e991522ca7e64e$var$render() {
    const state = $09e991522ca7e64e$var$game.getState();
    let idx = 0;
    for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
        const val = state[r][c];
        const el = $09e991522ca7e64e$var$cells[idx];
        el.className = "field-cell";
        if (val !== 0) {
            el.textContent = val;
            el.classList.add(`field-cell--${val}`);
        } else el.textContent = "";
        idx++;
    }
    $09e991522ca7e64e$var$scoreEl.textContent = $09e991522ca7e64e$var$game.getScore();
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    $09e991522ca7e64e$var$startBtn.className = "button";
    if (gameStatus === "not_started") {
        $09e991522ca7e64e$var$startBtn.textContent = "Start";
        $09e991522ca7e64e$var$startBtn.classList.add("start");
        $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
    } else if (gameStatus === "playing") {
        $09e991522ca7e64e$var$startBtn.textContent = "Restart";
        $09e991522ca7e64e$var$startBtn.classList.add("restart");
    } else if (gameStatus === "won") {
        $09e991522ca7e64e$var$startBtn.textContent = "Restart";
        $09e991522ca7e64e$var$startBtn.classList.add("restart");
        $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    } else if (gameStatus === "over") {
        $09e991522ca7e64e$var$startBtn.textContent = "Restart";
        $09e991522ca7e64e$var$startBtn.classList.add("restart");
        $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
    }
}
document.addEventListener("keydown", (e)=>{
    let moved = false;
    switch(e.key){
        case "ArrowLeft":
            moved = $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $09e991522ca7e64e$var$game.moveDown();
            break;
    }
    if (moved) $09e991522ca7e64e$var$render();
});
$09e991522ca7e64e$var$startBtn.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "not_started") $09e991522ca7e64e$var$game.start();
    else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$render();
});
$09e991522ca7e64e$var$render();


//# sourceMappingURL=index.e53e1151.js.map
